import { render, staticRenderFns } from "./ItemBox.vue?vue&type=template&id=5229b50e&"
import script from "./ItemBox.vue?vue&type=script&lang=js&"
export * from "./ItemBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports